export default __webpack_public_path__ + "images/9fba459825572ab8889ad4fa069af6bd.svg";